var _path, _g, _path2, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBgSurvey02(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 180,
    viewBox: "20 0 98 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_1",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 74,
    width: 30,
    height: 106
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.3516 77.6238V128.996C49.3516 140.973 44.8618 152.517 36.7614 161.371L20.2116 179.458H20.0833V178.764L36.3441 160.992C44.3682 152.222 48.7872 140.859 48.7872 128.996V77.6238C48.7872 76.2398 47.6497 75.4125 46.5498 75.4125C46.1164 75.4125 45.4845 75.5388 44.9354 76.1388L20.0833 103.3V102.465L44.5184 75.7599C45.0932 75.1317 45.8279 74.8511 46.5498 74.8511C47.9755 74.8511 49.3516 75.9457 49.3516 77.6238Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.3516 77.6238V128.996C49.3516 140.973 44.8618 152.517 36.7614 161.371L20.2116 179.458H20.0833V178.764L36.3441 160.992C44.3682 152.222 48.7872 140.859 48.7872 128.996V77.6238C48.7872 76.2398 47.6497 75.4125 46.5498 75.4125C46.1164 75.4125 45.4845 75.5388 44.9354 76.1388L20.0833 103.3V102.465L44.5184 75.7599C45.0932 75.1317 45.8279 74.8511 46.5498 74.8511C47.9755 74.8511 49.3516 75.9457 49.3516 77.6238Z",
    fill: "url(#paint0_linear_0_1)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_0_1",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 98,
    height: 112
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.8684 0C97.2754 0 98.5374 2.86303 96.9164 4.64511L0.479752 110.685C0.349213 110.829 0.217155 110.971 0.0835571 111.111V41.9876L26.1205 13.3589C33.859 4.84971 44.8176 0 56.3072 0H94.8684Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.8684 -0.541992C97.2754 -0.541992 98.5374 2.32104 96.9164 4.10312L20.4798 90.1433C20.3492 90.2869 20.2172 90.4289 20.0836 90.5691V21.4456L26.1205 12.8169C33.859 4.30772 44.8176 -0.541992 56.3072 -0.541992H94.8684Z",
    fill: "url(#paint1_linear_0_1)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_1",
    x1: 20.0833,
    y1: 127.155,
    x2: 49.3516,
    y2: 127.155,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C4728"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFB764"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFB764"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_0_1",
    x1: -56.4999,
    y1: 115,
    x2: 98,
    y2: -0.999976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C4728"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFB764"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFB764"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgSurvey02);
export default __webpack_public_path__ + "static/media/bg_survey_02.2d808b3c0f4f0f7f38c3d89455ade957.svg";
export { ForwardRef as ReactComponent };